import { createApp } from 'vue'
import cart from './cart.vue';
import cartStore from './store'

export default () => {
  createApp(cart).use(cartStore).mount("vue-cart")
}